import React from 'react';
import { Redirect } from 'react-router';
import NoSidebar from '../../layout/NoSidebar';
import { HasToBeLoggedInGuard } from '../../guards/HasToBeLoggedInGuard';
import { CannotBeLoggedInGuard } from '../../guards/CannotBeLoggedInGuard';

const commonRoutes = [
  {
    path: '/register',
    component: React.lazy(
      () => import('../../../main/register-page/RegisterPage')
    ),
    canActivate: [CannotBeLoggedInGuard],
    layout: NoSidebar,
  },
  {
    path: '/dashboard',
    exact: true,
    component: React.lazy(() => import('../../../main/dashboard/Dashboard')),
    canActivate: [HasToBeLoggedInGuard],
  },
  {
    path: '/claim-account',
    component: React.lazy(
      () => import('../../../main/claim-account/ClaimAccountPage')
    ),
    layout: NoSidebar,
  },
  {
    path: '/reset-password',
    component: React.lazy(
      () => import('../../../main/reset-password/ResetPasswordPage')
    ),
    layout: NoSidebar,
  },
  {
    path: '/forgot-password',
    component: React.lazy(
      () => import('../../../main/reset-password/ForgotPasswordPage')
    ),
    layout: NoSidebar,
  },
  // NOTIFICATIONS, REMINDERS
  {
    path: '/n/:messageId',
    component: React.lazy(
      () => import('../../../main/common/messaging/NotificationsHome')
    ),
    layout: NoSidebar,
  },
  {
    path: '/l/:messageId',
    component: React.lazy(
      () => import('../../../main/common/messaging/NotificationsHome')
    ),
    layout: NoSidebar,
    canActivate: [HasToBeLoggedInGuard],
  },
  {
    path: '/r/:reportId',
    component: React.lazy(
      () => import('../../../main/common/reports/ViewReportPage')
    ),
    layout: NoSidebar,
  },
  {
    path: '/resend-email',
    component: React.lazy(
      () => import('../../../main/resend-email/ResendEmailPage')
    ),
    canActivate: [CannotBeLoggedInGuard],
    layout: NoSidebar,
  },
  {
    path: '/auth/login',
    component: React.lazy(() => import('../../../main/auth/Login')),
    canActivate: [CannotBeLoggedInGuard],
    layout: NoSidebar,
  },
  {
    path: '/auth/login-as/:id',
    component: React.lazy(() => import('../../../main/auth/login-as/LoginAs')),
    layout: NoSidebar,
  },
  {
    path: '/auth/login-oauth',
    component: React.lazy(
      () => import('../../../main/auth/login-oauth/LoginOauth')
    ),
    layout: NoSidebar,
  },
  {
    path: '/auth/logout',
    component: React.lazy(() => import('../../../main/auth/Logout')),
    layout: NoSidebar,
  },
  {
    path: '/auth/logged-out',
    component: React.lazy(() => import('../../../main/auth/LoggedOut')),
    layout: NoSidebar,
  },
  // unauthorized routes
  {
    path: '/auth',
    exact: true,
    component: () => <Redirect to={'/auth/login'} />,
  },

  // main route redirect to auth
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={'/dashboard'} />,
  },
  // route not found
  {
    component: React.lazy(() => import('../../../main/errors/Error404Page')),
    layout: NoSidebar,
  },
];

export default commonRoutes;
